import React from "react";
import { Link } from "react-router-dom";
import TypeaheadSearch, { SearchType } from "../../TypeaheadSearch";
import "./dashboard.css";

const Dashboard = () => {
  const navigationCards = [
    {
      title: "Клієнти",
      description: "Управління базою клієнтів",
      link: "/client-list",
      icon: "👥",
      color: "#6366f1",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      title: "Створити Візит",
      description: "Додати новий візит клієнта",
      link: "/new-visit",
      icon: "📅",
      color: "#10b981",
      gradient: "linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)"
    },
    {
      title: "Склад",
      description: "Управління товарами та запасами",
      link: "/product-list",
      icon: "📦",
      color: "#f59e0b",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    },
    {
      title: "Каталог Послуг",
      description: "Перегляд та редагування послуг",
      link: "/service-list",
      icon: "✨",
      color: "#8b5cf6",
      gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)"
    },
    {
      title: "Звіти",
      description: "Аналітика та фінансові звіти",
      link: "/reports",
      icon: "📊",
      color: "#ec4899",
      gradient: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)"
    }
  ];

  return (
    <div className="dashboard">
      <div className="dashboard__header">
        <h1 className="dashboard__title">Домівка</h1>
        <p className="dashboard__subtitle">Ласкаво просимо до панелі управління</p>
      </div>

      <div className="dashboard__search-section">
        <div className="dashboard__search-card">
          <h2 className="dashboard__search-title">Швидкий пошук</h2>
          <TypeaheadSearch searchType={SearchType.CLIENTS} />
        </div>
      </div>

      <div className="dashboard__navigation">
        <h2 className="dashboard__section-title">Основні розділи</h2>
        <div className="dashboard__cards-grid">
          {navigationCards.map((card) => (
            <Link
              key={card.link}
              to={card.link}
              className="dashboard__card"
              style={{ '--card-gradient': card.gradient } as React.CSSProperties}
            >
              <div className="dashboard__card-icon">{card.icon}</div>
              <div className="dashboard__card-content">
                <h3 className="dashboard__card-title">{card.title}</h3>
                <p className="dashboard__card-description">{card.description}</p>
              </div>
              <div className="dashboard__card-arrow">→</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;